export default "__VITE_ASSET__dlHOMtmC__"